import * as Sentry from "@sentry/vue"

function sentryOn() {
  return window.sentryEnabled === true
}

function getJsonStringOrDefault(data) {
  if (data == null) return null
  if (typeof Blob !== "undefined" && data instanceof Blob) return null
  if (typeof File !== "undefined" && data instanceof File) return null
  if (typeof FileList !== "undefined" && data instanceof FileList) return null
  if (typeof data === "object") {
    try {
      return JSON.stringify(data)
    } catch (_) {
      return null
    }
  }
  if (typeof data === "string") {
    try {
      return JSON.stringify(JSON.parse(data))
    } catch (_) {
      return null
    }
  }
  return null
}

function getHeaders(headers) {
  if (!headers) return {}
  return {
    x_session_id: headers['X-Session-Id'],
    x_correlation_id: headers['X-Correlation-Id'],
  }
}

export function addHttpRequestBreadcrumb(config, fallbackBaseURL = "") {
  if (!sentryOn()) return
  Sentry.addBreadcrumb({
    category: "http.request",
    level: "info",
    data: {
      method: (config.method || "get").toUpperCase(),
      url: config.url || "",
      params: config.params || undefined,
      data: config.data || undefined,
      headers: getHeaders(config.headers),
    },
  })
}

export function addHttpResponseBreadcrumb(response) {
  if (!sentryOn()) return
  Sentry.addBreadcrumb({
    category: "http.response",
    level: "info",
    data: {
      method: (response.config?.method || "get").toUpperCase(),
      url: response.config?.url || "",
      status: response.status,
      data: getJsonStringOrDefault(response.data),
      headers: {
        ...getHeaders(response.headers),
        x_request_id: response.config?.headers?.['X-Request-Id'],
      },
    },
  })
}

export function addHttpErrorBreadcrumb(error) {
  if (!sentryOn()) return
  Sentry.addBreadcrumb({
    category: "http.response",
    level: "error",
    data: {
      method: (error.config?.method || "get").toUpperCase(),
      url: error.config?.url || "",
      status: error.response?.status || null,
      data: getJsonStringOrDefault(error.response?.data),
      headers: {
        ...getHeaders(error.config?.headers || error.response?.headers),
        x_request_id: error.config?.headers?.['X-Request-Id'],
      },
    },
  })
}
